import { FormsWritebacks } from '@frontend/api-forms';

export const STATUS_CODE_FOR_SHOWING_SWITCH_UI: (FormsWritebacks.Types.WritebackStatusCode | 'Not Applicable')[] = [
  'Failed',
  'Pending',
  'Manual',
];
